var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticClass:"content-filter-select",attrs:{"value":_vm.value,"size":"mini"},on:{"change":function($event){return _vm.$emit('change', $event)}}},_vm._l((_vm.options),function({ label, value },idx){return _c('el-option',{key:`content-filter-select-${label}-${value}-${idx}`,attrs:{"label":label,"value":value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }